// ======================================================================
// File Name       : CourseDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import PropTypes from 'prop-types';
import { Component } from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as containerActions from '../../actions/ContainerAction';
import * as courseActions from '../../actions/CourseAction';
import * as modalActions from '../../actions/ModalAction';
import * as userAction from '../../actions/UserAction';
import { BasicSetting, CourseRelation, DetailSetting } from '../../components/course/CourseDetail';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { MODE, RETURN_MAX_NUM_1000 } from '../../constants';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import { REDIRECT_MODAL } from '../../constants/CourseConstants';
import * as FunctionConstants from '../../constants/FunctionConstants';
import * as ModalIds from '../../constants/ModalIds';
import { SHOW_MESSAGE } from '../../constants/actionTypes/message';
import { canAccess } from '../../utils/AuthedUtils';
import UserAttributeDetailConfirmContainer from '../userAttribute/UserAttributeDetailConfirmContainer';

let okBtnClick = false;
class CourseDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.handleEditBtn = this.handleEditBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleOKBtn = this.handleOKBtn.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(userAction.getGroupListAll());
  }

  handleEditBtn() {
    const { dispatch, modalId, course } = this.props;
    const { editingCourse } = course;
    const { dataAffiliationType, itemListForCourseEnd } = editingCourse;
    dispatch(courseActions.changeEditType(MODE.EDIT_MODE));
    dispatch(containerActions.selectedItemOnDialog(itemListForCourseEnd)); // Step 10.2.0
    if (dataAffiliationType && dataAffiliationType === DATA_AFFIILIATION_TYPE.EXTERNAL) {
      dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK_EXTERNAL));
    } else {
      dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
    }
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleOKBtn() {
    const { dispatch, modalId } = this.props;
    if (!okBtnClick) {
      okBtnClick = true;
      dispatch(courseActions.saveCourse()).then(() => {
        okBtnClick = false;
      }).catch((error) => {
        const messageInfo = {
          statusCd: error.statusCd,
          message: error.message,
          targetModal: true,
          messageType: 'danger',
        };
        dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].ERROR));
        dispatch({ type: SHOW_MESSAGE, ...messageInfo });
        okBtnClick = false;
      });
    }
  }

  getModalOptions() {
    const { modalId, course, user } = this.props;
    const { userCourseRelation } = user;
    const courseDetailOption = {
      title: 'コース詳細',
      footerBtns: [{ name: 'キャンセル', onClick: this.props.hideModal, variant:'default' }],
      dialogClassName: 'course-edit-user-dialog',
    };
    if (canAccess(FunctionConstants.COURSE_EDIT) && course.editingCourse.dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL) {
      courseDetailOption.footerBtns.push({
        name: '編集・ユーザー紐付け',
        onClick: this.handleEditBtn,
        variant: 'primary',
      });
    }
    if (canAccess(FunctionConstants.COURSE_EDIT) && course.editingCourse.dataAffiliationType === DATA_AFFIILIATION_TYPE.EXTERNAL) {
      courseDetailOption.footerBtns.push({
        name: 'ユーザー紐付け',
        onClick: this.handleEditBtn,
        variant: 'primary',
      });
    }
    const OPTIONS = {
      [ModalIds.COURSE_DETAIL]: courseDetailOption,
      [ModalIds.COURSE_CONFIRM]: {
        title: '以下の内容を登録します',
        footerBtns: [
          { name: '戻る', onClick: this.handleBackBtn, variant: 'default' },
          { name: 'OK', onClick: this.handleOKBtn, variant: 'primary' },
        ],
        dialogClassName: 'course-edit-user-dialog',
      },
    };

    return OPTIONS[modalId];
  }

  render() {
    const { course, users, authority, modalId, groupList, structures, selectedItemList } = this.props;
    const { courses, courseRelations, selectedCourseGroupRelationList, recordNumGroupCourseRelation } = course;
    const recordNumCourseRelations = courseRelations ? courseRelations.recordNum : 0;
    const recordNumGroupCourseRelations = recordNumGroupCourseRelation || 0;
    const isShowMessageMaxRecord = recordNumCourseRelations > RETURN_MAX_NUM_1000;
    const isShowMessageGroupMaxRecord = recordNumGroupCourseRelations > RETURN_MAX_NUM_1000;
    const { allGroup } = this.props.user;
    let groupListData = groupList;
    if (allGroup && allGroup.length) {
      groupListData = allGroup;
    }
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <Form className='form-horizontal'>
          <div className="margin-left-right-minus-15">
            <BasicSetting
              course={course.editingCourse}
              editType={course.editType}
            />
            <DetailSetting course={course.editingCourse} structures={structures} selectedItemList={selectedItemList} />
            <UserAttributeDetailConfirmContainer />
          </div>
          <CourseRelation
            data={course.editingUser}
            users={course.userList}
            courseGroupRelation={selectedCourseGroupRelationList}
            groupList={groupListData}
            authority={authority}
            isShowMessageMaxRecord={isShowMessageMaxRecord}
            isDetail={modalId === ModalIds.COURSE_DETAIL}
            user={this.props.user}
            isShowMessageGroupMaxRecord={isShowMessageGroupMaxRecord}
          />
        </Form>
      </ModalWrapper>
    );
  }
}

CourseDetailContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  course: PropTypes.shape().isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { authority, course, authed, user, group, container: { structures } } = state;
  const { groupList } = group;
  // Step 10.2.0 START
  let selectedItemList;
  if (state.container.selectedItemList && Object.keys(state.container.selectedItemList).length > 0) {
    selectedItemList = state.container.selectedItemList;
  } else {
    selectedItemList = state.course.selectedItemList;
  }
  // Step 10.2.0 END
  return {
    course,
    authority: authority.authorityInfo,
    groupList,
    user,
    structures,
    selectedItemList,
  };
};
export default connect(mapStateToProps)(CourseDetailContainer);
